import { ChevronRight, Download, Monitor } from "lucide-react";
import { baixarInstaladorDoAtalho } from "@/lib/atalho-de-etiquetas";
import { ehEstacaoDeEtiquetas } from "@/lib/estacao-de-etiquetas";
import { AtalhoManual } from "./AtalhoManual";

const PASSOS = [
  "No computador ligado à impressora de etiquetas, deixe-a como impressora padrão do Windows (Configurações › Impressoras e scanners).",
  "Nas preferências dessa impressora, escolha o papel do tamanho da etiqueta (ex.: 100 × 150 mm) e margens zero.",
  "Baixe o instalador abaixo. O navegador avisa que o arquivo pode ser perigoso: clique em Manter.",
  "Abra o arquivo baixado. O Windows pergunta se deseja executar: clique em Executar (se aparecer a tela azul, Mais informações › Executar assim mesmo).",
  "Abra o atalho \"DentalBook Etiquetas\" que apareceu na área de trabalho, entre com sua conta e permita pop-ups na primeira vez.",
];

/**
 * Impressão sem diálogo no PC da impressora: um atalho do navegador com impressão direta, num perfil
 * só dele. Aceitar o pedido por essa janela já imprime; o navegador do dia a dia continua perguntando.
 */
export function ImpressaoDireta() {
  const nestaJanela = ehEstacaoDeEtiquetas();
  return (
    <div className="space-y-3 rounded-lg border border-zinc-200 bg-zinc-50/60 p-3 dark:border-border dark:bg-muted/30">
      <div className="flex items-start gap-2">
        <Monitor className="mt-0.5 h-4 w-4 shrink-0 text-brand-600 dark:text-primary" />
        <div>
          <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">Imprimir direto, sem perguntar</p>
          <p className="text-[12px] text-zinc-500 dark:text-muted-foreground">
            No computador da impressora (Windows), aceitar o pedido já imprime as etiquetas, sem a janela de impressão.
          </p>
        </div>
      </div>
      {nestaJanela ? (
        <p className="rounded-md bg-emerald-50 px-3 py-2 text-[12px] font-medium text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400">
          Esta janela é a de etiquetas: o que for aceito aqui imprime direto.
        </p>
      ) : (
        <>
          <details className="group rounded-md border border-zinc-200 bg-white dark:border-border dark:bg-card">
            <summary className="flex cursor-pointer list-none items-center gap-1.5 px-3 py-2 text-[12.5px] font-semibold text-zinc-700 dark:text-foreground [&::-webkit-details-marker]:hidden">
              <ChevronRight className="h-3.5 w-3.5 transition-transform group-open:rotate-90" />
              Como configurar (5 passos)
            </summary>
            <ol className="list-decimal space-y-1 border-t border-zinc-100 py-2.5 pl-8 pr-3 text-[12px] text-zinc-600 dark:border-border dark:text-muted-foreground">
              {PASSOS.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ol>
          </details>
          <button
            type="button"
            onClick={baixarInstaladorDoAtalho}
            className="inline-flex h-9 items-center gap-1.5 rounded-md border border-zinc-200 bg-white px-3 text-[12.5px] font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted"
          >
            <Download className="h-3.5 w-3.5" />
            Baixar instalador do atalho
          </button>
          <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
            O atalho também abre sozinho quando o computador liga. Recibos e orçamentos continuam no navegador do dia a dia, que
            pergunta a impressora.
          </p>
          <details className="group rounded-md border border-zinc-200 bg-white dark:border-border dark:bg-card">
            <summary className="flex cursor-pointer list-none items-center gap-1.5 px-3 py-2 text-[12.5px] font-semibold text-zinc-700 dark:text-foreground [&::-webkit-details-marker]:hidden">
              <ChevronRight className="h-3.5 w-3.5 transition-transform group-open:rotate-90" />
              O antivírus bloqueou? Crie o atalho à mão
            </summary>
            <AtalhoManual />
          </details>
        </>
      )}
    </div>
  );
}
